const INITIAL_STATE = {
  tabSelected: 1,
  isTraining: false
};

export default function desktopReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "CHANGE_TAB":
      return {
        ...state,
        tabSelected: action.tabSelected
      };
    case "SET_TRAINING": 
      return {
        ...state,
        isTraining: action.isTraining
      }
    case "RESET":
      return {
        tabSelected: 1
      };
    default:
      return state;
  }
}